const namespace = 'binder';

export const STUDENT_QUIZ_REMOVE_REQUEST = `${namespace}/STUDENT_QUIZ_REMOVE_REQUEST`;
export const STUDENT_QUIZ_REMOVE_SUCCESS = `${namespace}/STUDENT_QUIZ_REMOVE_SUCCESS`;

export const STUDENT_WRITE_REVISION_REQUEST = `${namespace}/STUDENT_WRITE_REVISION_REQUEST`;
export const STUDENT_WRITE_REVISION_SUCCESS = `${namespace}/STUDENT_WRITE_REVISION_SUCCESS`;
